<template>
  <main class="auth-page">
    <RouterLink to="/" class="back-link light">← 返回首页</RouterLink>
    <section class="auth-stage">
      <RouterLink to="/" class="auth-wordmark">Nova·云枢</RouterLink>
      <section class="auth-card">
        <slot />
      </section>
    </section>
  </main>
</template>
